import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ProviderListComponent } from './provider-list/provider-list.component';
import { ProviderImportComponent } from './provider-import/provider-import.component';
import { ProviderEditComponent } from './provider-edit/provider-edit.component';
import { AddressValidatorModule } from '../shared/address-validator/address-validator.module';
import { ProviderServiceSearchComponent } from './provider-service-search/provider-service-search.component';
import { Kno2ServiceSearchComponent } from './kno2-service-search/kno2-service-search.component';
import { DirectorySearchModule } from '../shared/directory-search/directory-search.module';
import { ProviderSearchModule } from '../shared/provider-search/provider-search.module';
import { Kno2SearchModule } from '../shared/kno2-search/kno2-search.module';

@NgModule({
  imports: [
    SharedModule,
    AddressValidatorModule,
    DirectorySearchModule,
    ProviderSearchModule,
    Kno2SearchModule
  ],
  declarations: [
    ProviderListComponent,
    ProviderEditComponent,
    ProviderImportComponent,
    ProviderServiceSearchComponent,
    Kno2ServiceSearchComponent
  ],
  exports: [
  ]
})
export class ProviderModule { }
